const defaultDataSet = [
  {
    label: null,
    backgroundColor: 'rgba(230, 162, 60, 0.1)',
    data: null,
    lineTension: 0,
    borderWidth: 4,
    borderColor: 'rgba(230, 162, 60, 0.9)',
    pointRadius: 0,
    pointHitRadius: 25,
  },
  {
    label: null,
    backgroundColor: 'rgba(158, 183, 74, 0.1)',
    data: null,
    lineTension: 0,
    borderWidth: 4,
    borderColor: 'rgba(158, 183, 74, 0.9)',
    pointRadius: 0,
    pointHitRadius: 25,
  },
]

export { defaultDataSet }
